import { render } from "./MenuSocial.vue?vue&type=template&id=71b2acf2"
import script from "./MenuSocial.vue?vue&type=script&lang=js"
export * from "./MenuSocial.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__